import React, { useRef, useState, useEffect } from "react";
import Inputbox from "../Components/Inputbox";
import DropDownButton, {
  DropDownManuCustom,
  DropDownManuCustomMulti,
} from "../Components/DropDownButton";
import { useNavigate } from "react-router-dom";
import {
  Clinicrequestlist,
  FetchDegreetType,
  FetchLanguage,
  GetCategory,
  GetConditionTreated,
  GetProviderType,
  GetServiceParactiseaddress,
} from "../../api/helper";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import { Dropdowniconn } from "../assest/SvgImages";
import { Box, Modal } from "@mui/material";
import { ShowToast } from "../../helpers/ToastService";
import { useLoadScript, Autocomplete } from "@react-google-maps/api";
import moment from "moment";

const eighteenYearsAgo = new Date();
eighteenYearsAgo.setFullYear(eighteenYearsAgo.getFullYear() - 18);

const validationSchema = Yup.object().shape({
  firstName: Yup.string()
    .required("First Name is required")
    .min(2, "First Name must be at least 2 characters"),

  lastName: Yup.string()
    .required("Last Name is required")
    .min(2, "Last Name must be at least 2 characters"),

  email: Yup.string()
    .email("Invalid email format")
    .required("Email is required"),

  phone: Yup.string()
    .required("Phone Number is required")
    .matches(/^[0-9]+$/, "Phone number must be digits")
    .min(10, "Phone number must be at least 10 digits")
    .max(15, "Phone number cannot exceed 15 digits"),

  categoryId: Yup.array()
    .of(Yup.string().required("A Specialities must be selected"))
    .min(1, "At least one Specialities is required")
    .required("Specialities is required"),

  ProviderNPI: Yup.string()
    .required("Provider NPI is required")
    .matches(/^[0-9]{10}$/, "Provider NPI must be 10 digits"),
  experience: Yup.string().required("Experience is required"),
  password: Yup.string()
    .required("Password is required")
    .min(12, "Password must be at least 12 characters")
    .matches(/[A-Z]/, "Password must contain at least one uppercase letter")
    .matches(/[a-z]/, "Password must contain at least one lowercase letter")
    .matches(/[0-9]/, "Password must contain at least one number")
    .matches(
      /[!@#$%^&*_,]/,
      "Password must contain at least one special character (!, @, #, $, %, ^, &, *, _)"
    )
    .notOneOf(
      ["password", "12345", "qwerty"],
      "Password is too common or easy to guess"
    ) // Add more common words as needed
    .test(
      "no-repeated-characters",
      "Password should not contain repeated characters like 'aaaa' or '1111'",
      (value) => {
        return !/(.)\1{3,}/.test(value); // Adjust this to your repeated character tolerance
      }
    )
    .test(
      "no-simple-patterns",
      "Password should not contain common patterns like 'abcd' or '1234'",
      (value) => {
        const patterns = ["abcd", "1234", "qwerty"]; // Add more patterns as needed
        return !patterns.some((pattern) => value.includes(pattern));
      }
    ),

  confirmPassword: Yup.string()
    .oneOf([Yup.ref("password"), null], "Passwords must match")
    .required("Confirm password is required"),

  // degreeType: Yup.string().required("Degree Type is required"),
  degreeTypeId: Yup.array()
    .of(Yup.string().required("A Degree Type must be selected"))
    .min(1, "At least one Degree Type is required")
    .required("Degree Type is required"),
  // ProviderType: Yup.string().required("Provider Type is required"),

  ProviderHomeAddress: Yup.string().required(
    "Provider Home Address is required"
  ),

  DOB: Yup.date()
    .typeError("Date of Birth must be a valid date")
    .required("Date of Birth is required")
    .max(eighteenYearsAgo, "You must be at least 18 years old")
    .test(
      "notToday",
      "Date of Birth cannot be today's date",
      (value) => value && value < new Date().setHours(0, 0, 0, 0)
    ),
  // NPI: Yup.string()
  //   .required("NPI is required")
  //   .matches(/^[0-9]{10}$/, "NPI must be 10 digits"),
  gender: Yup.string().required("Gender is required"),

  info: Yup.string().required("Info is required"),
  // language: Yup.string().required("Please select a language"),
  LanguagesId: Yup.array()
    .of(Yup.string().required("A language must be selected"))
    .min(1, "At least one language is required")
    .required("language is required"),
  address: Yup.object().shape({
    // street: Yup.string().required('Street is required'),
    city: Yup.string().required("City is required"),
    state: Yup.string().required("State is required"),
    country: Yup.string().required("Country is required"),
    zipCode: Yup.string().required("Zip code is required"),
  }),
  agencyId: Yup.string().required("Agency Name & ID is required"),
});
const days = [
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
  "Sunday",
];
const SignupFirst = ({ onSubmitt }) => {
  const [showavailibleday, setShowavailibleday] = useState(false);
  const [imagePreview, setImagePreview] = useState(null);
  const [imaeg, setImages] = useState(null);
  const [saveData, setSaveData] = useState();
  const fileInputRef = useRef(null);
  const [specialtydata, setspecialtydata] = useState(null);
  const [formSubmit, setFormSubmit] = useState(null);
  const [availableDays, setAvailableDays] = useState([]);
  const [cliniclistdata, setcliniclistdata] = useState(null);
  const [servicelocation, setservicelocation] = useState([]);
  const [autocomplete, setAutocomplete] = useState(null);
  const [isAgencySelected, setIsAgencySelected] = useState(false);
  const [providerType, setproviderType] = useState([]);
  const [conditionTreated, setConditionTreated] = useState([]);
  const [addressAutocomplete, setAddressAutocomplete] = useState(null);
  const [address, setAddress] = useState("");
  const [data, setdata] = useState([]);
  const [Degreetypedata, setDegreetypedata] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const navigate = useNavigate();
  const [suggestedPassword, setSuggestedPassword] = useState("");
 const [weeklySchedule, setWeeklySchedule] = useState(
    days.reduce((acc, day) => {
      acc[day] = [];
      return acc;
    }, {})
  );

  useEffect(() => {
    setSuggestedPassword(generateStrongPassword());
  }, []);
  const generateStrongPassword = () => {
    const upper = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
    const lower = "abcdefghijklmnopqrstuvwxyz";
    const number = "0123456789";
    const special = "!@#$%^&*_";
    const all = upper + lower + number + special;

    let password = "";
    password += upper[Math.floor(Math.random() * upper.length)];
    password += lower[Math.floor(Math.random() * lower.length)];
    password += number[Math.floor(Math.random() * number.length)];
    password += special[Math.floor(Math.random() * special.length)];

    for (let i = 4; i < 12; i++) {
      password += all[Math.floor(Math.random() * all.length)];
    }

    return password
      .split("")
      .sort(() => 0.5 - Math.random())
      .join("");
  };
  const GetDegreetype = async (id) => {
    const response = await FetchDegreetType(`?id=${id}`);
    console.log(response?.data?.data, "data=====");
    setDegreetypedata(response?.data?.data);
  };
  const { isLoaded } = useLoadScript({
    googleMapsApiKey: "AIzaSyAoF8F2jhZ_6-77oYJi0hgGTbcVh-CCIEE",
    libraries: ["places"],
  });

  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    reset,
    watch,
    clearErrors,
  } = useForm({
    resolver: yupResolver(validationSchema),
  });
  const GetLanguage = async (id) => {
    const response = await FetchLanguage(`?id=${id}`);
    console.log(response?.data?.data, "data=====");
    setdata(response?.data?.data);
  };
  const handleAddressSelection = () => {
    const selectedPlace = addressAutocomplete.getPlace();
    if (selectedPlace.formatted_address) {
      setAddress(selectedPlace.formatted_address);
    }
  };

  // console.log("==asbdkas", watch());
  const Fetchclinic = async () => {
    try {
      const response = await Clinicrequestlist();
      const data = response?.data?.data?.data?.map((e) => {
        return {
          name: `${e.companyName} /${e.uniqueId}`,
          ...e,
        };
      });
      setcliniclistdata(data);
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    Fetchclinic();
  }, []);

  const FetchAddresslist = async (id) => {
    try {
      const response = await GetServiceParactiseaddress(id);
      setservicelocation(
        Array.isArray(response?.data?.data?.data)
          ? response?.data?.data?.data
          : []
      );
      // setservicelocation(response);
    } catch (error) {
      console.log(error);
    }
  };

  const fetchProviderType = async (id) => {
    const response = await GetProviderType(`?id=${id}`);
    setproviderType(response?.data?.data || []);
  };

  const fetchConditionTreated = async (id) => {
    const response = await GetConditionTreated(`?id=${id}`);
    console.log(response.data, "====>>>");
    setConditionTreated(response?.data?.data || []);
  };

  const handlePlaceSelect = async () => {
    const place = autocomplete.getPlace();
    const addressComponents = place.address_components;

    const getAddressComponent = (type) => {
      const component = addressComponents.find((c) => c.types.includes(type));
      return component ? component.long_name : "";
    };

    // Set country, state, and city
    setValue("address.country", getAddressComponent("country"));
    setValue(
      "address.state",
      getAddressComponent("administrative_area_level_1")
    );
    setValue("address.city", getAddressComponent("locality"));

    const streetNumber = getAddressComponent("street_number");
    const route = getAddressComponent("route");
    const sublocality = getAddressComponent("sublocality");
    const neighborhood = getAddressComponent("neighborhood");
    const premise = getAddressComponent("premise"); // Building name or room number
    const establishment = getAddressComponent("establishment"); // Business names

    let fullStreet = "";

    if (establishment) {
      fullStreet = establishment;
    } else if (premise) {
      fullStreet = `${premise}, ${route || sublocality || neighborhood}`;
    } else if (streetNumber && route) {
      fullStreet = `${streetNumber} ${route}`;
    } else if (sublocality) {
      fullStreet = sublocality;
    } else if (neighborhood) {
      fullStreet = neighborhood;
    }

    if (!fullStreet) {
      fullStreet = `${getAddressComponent("locality")}, ${getAddressComponent(
        "administrative_area_level_1"
      )}, ${getAddressComponent("country")}`;
    }

    // Set the full street address in the form
    setValue("address.street", fullStreet);

    // Set the zip code
    setValue("address.zipCode", getAddressComponent("postal_code"));
  };

  const handleChange = (e) => {
    setValue("phone", e);
  };

  const handleCloseModal = async (data) => {
    if (data == "Upload") {
      if (!imagePreview) {
        return ShowToast("Please Select Image", "error");
      }
      // saveData.image = imaeg;
    }
    setFormSubmit(data);
    setShowModal(false);
  };

  const onSubmit = async (data) => {
    if (availableDays.length === 0) {
      return ShowToast("Please select Available Days", "error");
    }
    data.availableDays = availableDays;
    data.DOB = moment(data.DOB).format("YYYY-MM-DD");
    onSubmitt(data);
  };

  const handleavailibledays = () => {
    setShowavailibleday(true);
  };
  const handleClose = () => {
    setShowavailibleday(false);
  };

  useEffect(() => {
    getSpecialty();
  }, []);
  const getSpecialty = async () => {
    try {
      const resposne = await GetCategory();
      setspecialtydata(resposne?.data?.data);
    } catch (error) {
      console.log(error);
    }
  };

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    height: "70vh", // Updated height to 70% of the viewport height
    bgcolor: "background.paper",
    borderRadius: "10px",
    boxShadow: 24,
    p: 4,
    overflowY: "auto", // Enables scrolling inside the modal box
  };

  const handleToggle = (dayName) => {
    setAvailableDays((prev) => {
      const isActive = prev.some((day) => day.day === dayName);
      if (isActive) {
        return prev.filter((day) => day.day !== dayName);
      } else {
        return [
          ...prev,
          { day: dayName, shifts: [{ startTime: "10:00", endTime: "18:00" }] },
        ];
      }
    });
  };

  const handleTimeChange = (dayName, newStartTime, newEndTime) => {
    setAvailableDays((prev) =>
      prev.map((day) => {
        if (day.day === dayName) {
          return {
            ...day,
            shifts: [{ startTime: newStartTime, endTime: newEndTime }],
          };
        }
        return day;
      })
    );
  };

 
  const options = [
    { _id: "0-1", name: "0-1 (New or Entry Level)" },
    { _id: "2-5", name: "2-5 (Early Career)" },
    { _id: "6-10", name: "6-10 (Experienced)" },
    { _id: "11-15", name: "11-15 (Advanced)" },
    { _id: "16-20+", name: "16-20+ (Expert or Senior Level)" },
  ];

  const handleSelect = (selectedOptions) => {
    let ids = selectedOptions.map((e) => e?._id);
    setValue("categoryId", ids, { shouldValidate: true });
  };
  const handleSelectdegreetype = (selectedOptions) => {
    let ids = selectedOptions.map((e) => e?._id);
    setValue("degreeTypeId", ids, { shouldValidate: true });
  };

  const handleSelectProviderType = (selectedOptions) => {
    let ids = selectedOptions?.map((e) => e?._id);
    setValue("ProviderType", ids, { shouldValidate: true });
  };

  const handleSelectConditionTreated = (selectedOptions) => {
    let ids = selectedOptions?.map((e) => e?._id);
    setValue("ConditionTreatedId", ids, { shouldValidate: true });
  };
  const handlelanguage = (selectedOptions) => {
    let ids = selectedOptions?.map((e) => e?._id);
    setValue("LanguagesId", ids, { shouldValidate: true });
  };
   const addTimeBlock = (day) => {
    const updated = { ...weeklySchedule };
    updated[day].push({ start: "09:00", end: "17:00" });
    setWeeklySchedule(updated);
  };

  const removeTimeBlock = (day, index) => {
    const updated = { ...weeklySchedule };
    updated[day].splice(index, 1);
    setWeeklySchedule(updated);
  };

  const handleTimeBlockChange = (day, index, field, value) => {
    const updated = { ...weeklySchedule };
    updated[day][index][field] = value;
    setWeeklySchedule(updated);
  };

  const handleSaveSettings = () => {
    const formattedData = {
      availableDays: Object.entries(weeklySchedule)
        .filter(([_, shifts]) => shifts.length > 0)
        .map(([day, shifts]) => ({
          day,
          shifts: shifts.map((shift) => ({
            startTime: shift.start,
            endTime: shift.end,
          })),
        })),
    };
    setAvailableDays(formattedData);
    console.log("Formatted Data:", formattedData);
    setShowavailibleday(false);
  };
  if (!isLoaded) return <div>Loading...</div>;
  return (
    <div>
      {/* <div style={{ width: "100%", display: "flex", height: "100vh" }}>
        <div
          style={{
            width: "50%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: "#041C32",
            flexDirection: "column",
          }}
        >
          <img
            src={require("../assest/Images/mindwellnewlogo.png")}
            style={{ height: "50%", width: "50%" }}
          />
          <div
            style={{
              color: "white",
              fontWeight: "bold",
              fontSize: "20px",
              marginTop: "20px",
            }}
          >
            Your trusted platform for mental health services.
          </div>
        </div>
        <div className="signup-container">
          <div className="signup-form" style={{ width: "85%" }}>
            <form onSubmit={handleSubmit(onSubmit)}> */}
      <div className="login-container">
        <div className="left-panel">
          <img
            src={require("../assest/Images/mindwellnewlogo.png")}
            alt="Mindwell Logo"
            className="logo"
          />
          <div className="slogan">
            Your trusted platform for mental health services.
          </div>
        </div>
        <div className="signup-container">
          <form onSubmit={handleSubmit(onSubmit)} className="signup-form">
            <h2>New Provider Registration</h2>
            <div className="input-row">
              <div className="form_div">
                <Inputbox
                  label="Legal First Name"
                  type="text"
                  placeholder="Enter First Name"
                  name="firstName"
                  register={register}
                />
                {errors.firstName && (
                  <div className="errorMessage">{errors.firstName.message}</div>
                )}
              </div>

              <div className="form_div">
                <Inputbox
                  label="Legal Last Name"
                  type="text"
                  placeholder="Enter Last Name"
                  name="lastName"
                  register={register}
                />
                {errors.lastName && (
                  <div className="errorMessage">{errors.lastName.message}</div>
                )}
              </div>
            </div>
            <div className="input-row">
              <div className="form_div">
                <DropDownManuCustom
                  label="Experience (Years)"
                  placeholder="Select option"
                  options={options}
                  name="experience"
                  dropdownicon
                  register={register}
                  id="_id"
                  clearErrors={clearErrors}
                />
                {errors.experience && (
                  <div className="errorMessage">
                    {errors.experience.message}
                  </div>
                )}
              </div>
            </div>

            <div className="input-row" style={{ marginTop: 15 }}>
              <div className="form_div">
                <Inputbox
                  label="Email Address"
                  type="email"
                  placeholder="Enter Email"
                  name="email"
                  register={register}
                />
                {errors.email && (
                  <div className="errorMessage">{errors.email.message}</div>
                )}
              </div>
              <div className="form_div_two">
                <Inputbox
                  style={{ width: "100%", height: 49 }}
                  label="Phone Number"
                  type="text"
                  placeholder="Enter Number"
                  name="phone"
                  onChange={handleChange}
                />
                {errors.phone && (
                  <div className="errorMessage">{errors.phone.message}</div>
                )}
              </div>
            </div>

            <div className="input-row">
              <div className="form_div">
                <Inputbox
                  label="Provider NPI"
                  type="text"
                  placeholder="Enter Provider NPI"
                  name="ProviderNPI"
                  register={register}
                />
                {errors.ProviderNPI && (
                  <div className="errorMessage">
                    {errors.ProviderNPI.message}
                  </div>
                )}
              </div>

              <div className="form_div">
                <Autocomplete
                  onLoad={(autocompleteInstance) =>
                    setAddressAutocomplete(autocompleteInstance)
                  }
                  onPlaceChanged={handleAddressSelection}
                >
                  <Inputbox
                    label="Provider Home Address"
                    type="text"
                    placeholder="Enter Provider Home Address"
                    name="ProviderHomeAddress"
                    register={register}
                  />
                </Autocomplete>
                {/* <Inputbox
                    label="Provider Home Address"
                    type="text"
                    placeholder="Enter Provider Home Address"
                    name="ProviderHomeAddress"
                    register={register}
                  /> */}
                {errors.ProviderHomeAddress && (
                  <div className="errorMessage">
                    {errors.ProviderHomeAddress.message}
                  </div>
                )}
              </div>
            </div>

            <div className="input-row" style={{ marginTop: 25 }}>
              <div className="form_div" style={{ marginTop: -20 }}>
                <Inputbox
                  label="Date of Birth"
                  k
                  type="date"
                  name="DOB"
                  register={register}
                  style={{
                    borderColor: errors.DOB ? "red" : "initial",
                    height: 40,
                  }}
                  max={new Date().toISOString().split("T")[0]}
                />
                {errors.DOB && (
                  <p className="errorMessage">{errors.DOB.message}</p>
                )}
              </div>
              <div className="form_div" style={{ marginTop: -20 }}>
                <DropDownManuCustom
                  label="Gender"
                  placeholder="Select option"
                  options={[
                    { _id: "Male", name: "Male" },
                    { _id: "Female", name: "Female" },
                    { _id: "Other", name: "Other" },
                  ]}
                  name="gender"
                  dropdownicon
                  register={register}
                />

                {errors.gender && (
                  <div className="errorMessage">{errors.gender.message}</div>
                )}
              </div>
            </div>

            <div className="input-row">
              <div className="form_div">
                <DropDownManuCustom
                  label="Agency Name & ID"
                  placeholder="Select option"
                  options={cliniclistdata}
                  name="agencyId"
                  dropdownicon
                  register={register}
                  id="_id"
                  clearErrors={clearErrors}
                  onSelect={(selectedOption) => {
                    console.log(selectedOption);
                    setIsAgencySelected(true);
                    FetchAddresslist(selectedOption?._id);
                    fetchProviderType(selectedOption?._id);
                    fetchConditionTreated(selectedOption?._id);
                    GetLanguage(selectedOption?._id);
                    GetDegreetype(selectedOption?._id);
                  }}
                />
                {errors.agencyId && (
                  <div className="errorMessage">{errors.agencyId.message}</div>
                )}
              </div>
            </div>
            <div className="form_div">
              <DropDownManuCustom
                label="Provider Primary Pratice Address"
                placeholder="Select Practice Location"
                options={servicelocation}
                name="ServiceLocationId"
                dropdownicon
                register={register}
                id="_id"
                clearErrors={clearErrors}
                disabled={!isAgencySelected}
              />
              {errors.ServiceLocationId && (
                <div className="errorMessage">
                  {errors.ServiceLocationId.message}
                </div>
              )}
            </div>

            <div className="input-row">
              <div className="form_div">
                <Autocomplete
                  onLoad={(autocompleteInstance) =>
                    setAutocomplete(autocompleteInstance)
                  }
                  onPlaceChanged={handlePlaceSelect}
                >
                  <Inputbox
                    label="Street"
                    type="text"
                    placeholder="Enter Street"
                    name="address.street"
                    register={register}
                  />
                </Autocomplete>
              </div>

              <div className="form_div">
                <Inputbox
                  label="City"
                  type="text"
                  placeholder="Enter City"
                  name="address.city"
                  register={register}
                />
                {errors.address?.city && (
                  <div className="errorMessage">
                    {errors.address.city.message}
                  </div>
                )}
              </div>
            </div>
            <div className="input-row">
              <div className="form_div">
                <Inputbox
                  label="State"
                  type="text"
                  placeholder="Enter State"
                  name="address.state"
                  register={register}
                />
                {errors.address?.state && (
                  <div className="errorMessage">
                    {errors.address.state.message}
                  </div>
                )}
              </div>
              <div className="form_div">
                <Inputbox
                  label="Country"
                  type="text"
                  placeholder="Enter Country"
                  name="address.country"
                  register={register}
                />
                {errors.address?.country && (
                  <div className="errorMessage">
                    {errors.address.country.message}
                  </div>
                )}
              </div>
            </div>
            <div className="form_div">
              <Inputbox
                label="Zip Code"
                type="text"
                placeholder="Enter Zip Code"
                name="address.zipCode"
                register={register}
              />
              {errors.address?.zipCode && (
                <div className="errorMessage">
                  {errors.address.zipCode.message}
                </div>
              )}
            </div>
            <DropDownManuCustomMulti
              label="Provider Type"
              placeholder="Select option"
              options={providerType}
              name="ProviderType"
              register={register}
              id="_id"
              clearErrors={clearErrors}
              onSelect={handleSelectProviderType}
            />
            <div style={{ marginTop: 20 }} />
            <DropDownManuCustomMulti
              label="Condition Treated"
              placeholder="Select option"
              options={conditionTreated}
              name="ConditionTreatedId"
              register={register}
              id="_id"
              clearErrors={clearErrors}
              onSelect={handleSelectConditionTreated}
              disabled={!isAgencySelected}
            />

            <div className="input-row">
              <div className="form_div" style={{ marginTop: 20 }}>
                <DropDownManuCustomMulti
                  label="Degree Type"
                  placeholder="Select option"
                  options={Degreetypedata}
                  name="degreeTypeId"
                  register={register}
                  id="_id"
                  clearErrors={clearErrors}
                  onSelect={handleSelectdegreetype}
                />
                {errors.degreeTypeId && (
                  <div className="errorMessage">
                    {errors.degreeTypeId.message}
                  </div>
                )}
              </div>
            </div>
            <div className="form_div">
              <DropDownManuCustomMulti
                label="Specialities"
                placeholder="Select option"
                options={specialtydata}
                name="categoryId"
                register={register}
                id="_id"
                clearErrors={clearErrors}
                onSelect={handleSelect}
              />
              {errors.categoryId && (
                <div className="errorMessage">{errors.categoryId.message}</div>
              )}
            </div>

            <lable
              style={{
                display: "flex",
                marginBottom: -10,
                color: "#273f5b",
                fontSize: "16px",
                fontWeight: "600",
                marginTop: 30,
              }}
            >
              Available Days
            </lable>
            <div
              className="Available_Days_divv"
              onClick={handleavailibledays}
              style={{ marginTop: 20 }}
            >
              <div>
                {" "}
                {(availableDays.length > 0 && (
                  <div className="selected-days">
                    {availableDays.map((e) => e.day).join(", ")}
                  </div>
                )) ||
                  "Available Days"}{" "}
              </div>
              <Dropdowniconn />
            </div>
            <div className="input-row" style={{ marginTop: 15 }}>
              <div className="form_div">
                <Inputbox
                  label="Short Biography "
                  placeholder="Enter Short Biography "
                  name="info"
                  register={register}
                  style={{ borderColor: errors.info ? "red" : "initial" }}
                />
                {errors.info && (
                  <p className="errorMessage">{errors.info.message}</p>
                )}
              </div>
            </div>
            <div className="form_div">
              <div>
                <DropDownManuCustomMulti
                  label="Language"
                  placeholder="Select option"
                  options={data}
                  name="LanguagesId"
                  register={register}
                  id="_id"
                  clearErrors={clearErrors}
                  onSelect={handlelanguage}
                />
                {errors.LanguagesId && (
                  <p className="errorMessage">{errors.LanguagesId.message}</p>
                )}
              </div>
            </div>
            <div className="input-row" style={{ marginTop: 15 }}>
              <div className="form_div">
                <Inputbox
                  label="Password"
                  type="password"
                  placeholder="Enter Password"
                  name="password"
                  register={register}
                  isPassword
                />
                {errors.password && (
                  <div className="errorMessage">{errors.password.message}</div>
                )}

                {suggestedPassword && (
                  <div className="suggest-password-box">
                    <span>Suggested: </span>
                    <button
                      type="button"
                      className="use-suggested-btn"
                      onClick={() => {
                        setValue("password", suggestedPassword);
                        setValue("confirmPassword", suggestedPassword);
                        clearErrors(["password", "confirmPassword"]);
                      }}
                    >
                      Use suggested password:{" "}
                      <strong>{suggestedPassword}</strong>
                    </button>
                  </div>
                )}
              </div>
              <div className="form_div">
                <Inputbox
                  label="Confirm Password"
                  type="password"
                  placeholder="Enter Confirm Password"
                  name="confirmPassword"
                  register={register}
                  isPassword
                />
                {errors.confirmPassword && (
                  <div className="errorMessage">
                    {errors.confirmPassword.message}
                  </div>
                )}
              </div>
            </div>
            <div className="display_div_dis">
              <div>
                <input type="checkbox" />
              </div>
              <div>
                <p className="I_have_txt">
                  I have read and agreed to the{" "}
                  <a href="#" style={{ color: "#bc9c22" }}>
                    {" "}
                    Terms & Conditions{" "}
                  </a>
                  and
                  <a href="#" style={{ color: "#bc9c22" }}>
                    {" "}
                    Privacy Policy
                  </a>
                </p>
              </div>
            </div>
            {/* <button className="login-button">Next</button> */}
            <input className="login-button" type="submit" value="Next" />
            <p className="login-text">
              Already have an Account?{" "}
              <a
                onClick={() => {
                  navigate("/");
                }}
                style={{ cursor: "pointer" }}
              >
                Log In
              </a>
            </p>
          </form>
        </div>
      </div>

     {showavailibleday && (
        <div id="settings-modal" className="modal_CalendarView">
          <div className="modal-content_CalendarView">
            <div className="close_CalendarView">
              <span onClick={() => setShowavailibleday(false)}>&times;</span>
            </div>
            <h2>Working Hours Settings</h2>
            <p>Configure your working hours and scheduling constraints.</p>

            <div id="settings-days-container" style={{ marginBottom: 20 }}>
              {days.map((day) => (
                <div key={day} className="day-row_CalendarView">
                  <div className="day-row-header_CalendarView">
                    <strong>{day}</strong>
                    <button
                      type="button"
                      className="add-block-btn_CalendarView"
                      onClick={() => addTimeBlock(day)}
                    >
                      Add Time Block
                    </button>
                  </div>
                  <div className="time-blocks_CalendarView">
                    {weeklySchedule[day].map((block, index) => (
                      <div key={index} className="time-block_CalendarView">
                        <label>Start:</label>
                        <input
                          type="time"
                          value={block.start}
                          onChange={(e) =>
                            handleTimeBlockChange(
                              day,
                              index,
                              "start",
                              e.target.value
                            )
                          }
                        />
                        <label>End:</label>
                        <input
                          type="time"
                          value={block.end}
                          onChange={(e) =>
                            handleTimeBlockChange(
                              day,
                              index,
                              "end",
                              e.target.value
                            )
                          }
                        />
                        <button
                          type="button"
                          className="remove-block-btn_CalendarView"
                          onClick={() => removeTimeBlock(day, index)}
                        >
                          Remove
                        </button>
                      </div>
                    ))}
                  </div>
                </div>
              ))}
            </div>

            <div className="button-container_CalendarView">
              <button
                type="button"
                className="save-settings-button_CalendarView"
                onClick={handleSaveSettings}
              >
                Save
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default SignupFirst;
